"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CloseOutlined = _interopRequireDefault(require("@ant-design/icons/CloseOutlined"));
var _pickAttrs = _interopRequireDefault(require("rc-util/lib/pickAttrs"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function useInnerClosable(closable, closeIcon, defaultClosable) {
  if (typeof closable === 'boolean') {
    return closable;
  }
  if (typeof closable === 'object') {
    return true;
  }
  if (closeIcon === undefined) {
    return !!defaultClosable;
  }
  return closeIcon !== false && closeIcon !== null;
}
function useClosable(_ref) {
  let {
    closable,
    closeIcon,
    customCloseIconRender,
    defaultCloseIcon = /*#__PURE__*/_react.default.createElement(_CloseOutlined.default, null),
    defaultClosable = false
  } = _ref;
  const mergedClosable = useInnerClosable(closable, closeIcon, defaultClosable);
  if (!mergedClosable) {
    return [false, null];
  }
  const _a = typeof closable === 'object' ? closable : {},
    {
      closeIcon: closableIcon
    } = _a,
    restProps = __rest(_a, ["closeIcon"]);
  // Priority: closable.closeIcon > closeIcon > defaultCloseIcon
  const mergedCloseIcon = (() => {
    if (typeof closable === 'object' && closableIcon !== undefined) {
      return closableIcon;
    }
    return typeof closeIcon === 'boolean' || closeIcon === undefined || closeIcon === null ? defaultCloseIcon : closeIcon;
  })();
  const ariaProps = (0, _pickAttrs.default)(restProps, true);
  const plainCloseIcon = customCloseIconRender ? customCloseIconRender(mergedCloseIcon) : mergedCloseIcon;
  const closeIconWithAria = /*#__PURE__*/_react.default.isValidElement(plainCloseIcon) ? ( /*#__PURE__*/_react.default.cloneElement(plainCloseIcon, ariaProps)) : ( /*#__PURE__*/_react.default.createElement("span", Object.assign({}, ariaProps), plainCloseIcon));
  return [true, closeIconWithAria];
}
var _default = exports.default = useClosable;